/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResendPatientInvitationRequestDto
 */
export interface ResendPatientInvitationRequestDto {
    /**
     * Email of the patient to resend the invitation to
     * @type {string}
     * @memberof ResendPatientInvitationRequestDto
     */
    email: string;
}

/**
 * Check if a given object implements the ResendPatientInvitationRequestDto interface.
 */
export function instanceOfResendPatientInvitationRequestDto(value: object): value is ResendPatientInvitationRequestDto {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function ResendPatientInvitationRequestDtoFromJSON(json: any): ResendPatientInvitationRequestDto {
    return ResendPatientInvitationRequestDtoFromJSONTyped(json, false);
}

export function ResendPatientInvitationRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResendPatientInvitationRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function ResendPatientInvitationRequestDtoToJSON(json: any): ResendPatientInvitationRequestDto {
    return ResendPatientInvitationRequestDtoToJSONTyped(json, false);
}

export function ResendPatientInvitationRequestDtoToJSONTyped(value?: ResendPatientInvitationRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

